import { Box } from '@chakra-ui/react';
import { type GroupBase, type OptionBase, Select } from 'chakra-react-select';
import { getChakrastyles } from '@/components/Atoms/FaceliftSelect/cstyles';
import type { FaceliftSelectInnerProps } from '@/components/Atoms/FaceliftSelect/FaceliftSelect.types';
import {
	CheckboxOption,
	CustomPlaceholderLocal,
	DropdownIndicatorLocal,
	MenuListLocal,
} from '@/components/Atoms/FaceliftSelect/FaceliftSelectParts';

const FaceliftSelectInner = <
	Option extends OptionBase,
	IsMulti extends boolean = false,
>({
	items,
	isMulti,
	loading,
	placeholder,
	debouncedSearch,
	onScrollToBottom,
	borderRadius,
	solidGradiant,
	borderColor = 'brand.inputText',
	error = '',
	color = '',
	ai,
	bg = '',
	rounded,
	...rest
}: FaceliftSelectInnerProps<Option, IsMulti>) => {
	return (
		<Select<Option, IsMulti, GroupBase<Option>>
			size="sm"
			menuPosition="fixed"
			menuShouldScrollIntoView={false}
			isMulti={isMulti}
			options={items}
			hideSelectedOptions={false}
			placeholder={placeholder}
			isLoading={loading}
			closeMenuOnSelect={!isMulti}
			tagVariant="solid"
			selectedOptionStyle={isMulti ? 'color' : 'check'}
			onMenuScrollToBottom={onScrollToBottom ? onScrollToBottom : undefined}
			onInputChange={debouncedSearch}
			{...ai && {
				filterOption: null
			}}
			styles={{
				menuPortal: (provided) => ({
					...provided,
					zIndex: 1500,
				}),
			}}
			chakraStyles={getChakrastyles({
				borderRadius,
				solidGradiant,
				borderColor,
				isMulti,
				error,
				color,
				ai,
				bg,
				rounded,
			})}
			components={{
				Option: CheckboxOption,
				MenuList: MenuListLocal,
				DropdownIndicator: (props) => (
					<DropdownIndicatorLocal
						{...props}
						ai={ai}
						error={error}
						color={color}
					/>
				),
				Placeholder: CustomPlaceholderLocal,
				LoadingIndicator: () => <Box className="tripple-dot-loader" mr={2} />,
			}}
			{...rest}
		/>
	);
};

export default FaceliftSelectInner;
